import React from "react";
import { ConfigProvider, DatePicker, Form } from "antd";
import en from "antd/es/date-picker/locale/en_US";
import enUS from "antd/es/locale/en_US";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";

dayjs.extend(buddhistEra);

const DateTimeInput = ({
  format,
  showTime = false,
  defaultValue,
  onChange,
  label,
  name,
  rules,
  placeholder,
  form,
  ...rest
}) => {
  const buddhistLocale = {
    ...en,
    lang: {
      ...en.lang,
      dateFormat: "BBBB-MM-DD",
      dateTimeFormat: "BBBB-MM-DD HH:mm:ss",
    },
  };

  const globalBuddhistLocale = {
    ...enUS,
    DatePicker: {
      ...enUS.DatePicker,
      lang: buddhistLocale.lang,
    },
  };

  const handleChange = (date, dateString) => {
    const gregorianDate = date ? dayjs(date).format("YYYY-MM-DD HH:mm:ss") : null;
    form.setFieldsValue({ [name]: gregorianDate });
    if (onChange) onChange(gregorianDate, dateString);
  };

  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      {...rest}
      className="custom-input"
    >
      <ConfigProvider locale={globalBuddhistLocale}>
        <DatePicker
          defaultValue={defaultValue ? dayjs(defaultValue) : null}
          format={format || "BBBB-MM-DD HH:mm:ss"}
          showTime={showTime}
          onChange={handleChange}
          placeholder={placeholder || "Select date and time"}
        />
      </ConfigProvider>
    </Form.Item>
  );
};

export default DateTimeInput;
